import React, { FC } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { FormStepRecovery, FormStepIntensity } from '../workoutBuilderTypes';
import { RECOVERY_MODE_OPTIONS } from './conditioningSteps.constants';
import StepIntensityField from './StepIntensityField';
import styles from './ConditioningSteps.module.scss';

interface StepRecoveryFieldProps {
  value: FormStepRecovery;
  onChange: (r: FormStepRecovery) => void;
  label?: string;
  previewAthleteId?: string;
}

const StepRecoveryField: FC<StepRecoveryFieldProps> = ({
  value,
  onChange,
  label = 'Recupero',
  previewAthleteId,
}) => {
  return (
    <div className={styles.recoveryField}>
      <label className={styles.checkboxLabel}>
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={value.enabled}
          onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
        />
        <span className={styles.checkboxText}>{label}</span>
      </label>

      {value.enabled && (
        <div className={styles.inlineRow}>
          <div className={styles.selectWrapper}>
            <select
              className={styles.compactSelect}
              value={value.mode}
              onChange={(e) =>
                onChange({ ...value, mode: e.target.value as FormStepRecovery['mode'] })
              }
            >
              {RECOVERY_MODE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <CaretDown size={11} className={styles.selectIcon} />
          </div>
          <input
            type="number"
            className={styles.compactInput}
            placeholder="60"
            value={value.value}
            min={0}
            onChange={(e) => onChange({ ...value, value: e.target.value })}
          />
        </div>
      )}

      {value.enabled && (
        <div className={styles.activeRecovery}>
          <span className={styles.activeRecoveryHint}>Recupero attivo (opzionale)</span>
          <StepIntensityField
            value={value.intensity}
            previewAthleteId={previewAthleteId}
            onChange={(intensity: FormStepIntensity) => onChange({ ...value, intensity })}
          />
        </div>
      )}
    </div>
  );
};

export default StepRecoveryField;
